import Shimmer from "components/ui/shimmer"

import { MainContainer, Panel, LineItemCard } from "./components"
import { CardProductImageContainer } from "./line-item/components"

const CartLoading = () => (
  <div className="desktop:flex-row tablet:gap-16 mb-64 flex flex-col">
    <MainContainer>
      {[...Array(2)].map((_, index) => (
        <LineItemCard key={`cart-loading-item-${index}`}>
          <div
            className="desktop:gap-24 relative flex gap-16"
            style={{ "--base-height": "22px", "--tablet-height": "24px" }}
          >
            <CardProductImageContainer>
              <Shimmer className="w-(--base-width) desktop:w-(--desktop-width) aspect-square h-auto" />
            </CardProductImageContainer>
            <div className="flex-1">
              <Shimmer className="h-(--base-height) tablet:h-(--tablet-height) mb-8 w-3/5" />
              <Shimmer className="h-(--base-height) tablet:h-(--tablet-height) w-1/2" />
            </div>
          </div>
        </LineItemCard>
      ))}
    </MainContainer>
    <div className="desktop:w-1/3 tablet:pt-0 w-full pt-40">
      <Panel>
        <Shimmer className="mb-20" style={{ height: "24px", width: "60%" }} />
        <div className="my-20 flex justify-between">
          <Shimmer
            className="my-5"
            style={{ height: "14px", width: "100px" }}
          />
          <Shimmer className="my-5" style={{ height: "14px", width: "50px" }} />
        </div>
        <div className="mb-8 flex justify-between">
          <Shimmer className="my-5" style={{ height: "14px", width: "80px" }} />
          <Shimmer className="my-5" style={{ height: "14px", width: "70px" }} />
        </div>
        <div className="my-20 flex justify-between">
          <Shimmer
            className="my-5"
            style={{ height: "14px", width: "100px" }}
          />
          <Shimmer className="my-5" style={{ height: "14px", width: "85px" }} />
        </div>
        <Shimmer
          className="mt-16 rounded"
          style={{ height: "48px", width: "100%" }}
        />
      </Panel>
    </div>
  </div>
)

export default CartLoading
